import React from 'react';
import { inject, observer } from 'mobx-react';

import { returnColorByQcFlag, returnBgColorByQcFlag } from '../../../utils';
import { getDisplayDate } from '../../../libs/date';
import { toJS, observable, action } from 'mobx';
import _ from 'lodash';

@inject('hqcStore', 'stationStore')
@observer
export default class ObservationsTable extends React.Component {

    findDuplicates(arr, fields) {
        const seen = {};
        const duplicate = [];
        arr.forEach((item) => {
            const currentKey = fields.map((field) => item[field]).join("-");
            const existingValue = seen[currentKey];
            if (existingValue) duplicate.push(existingValue);
            seen[currentKey] = item;
        });
        return duplicate;
    }

    @action selectColumnDuplicates = (index) => {
        const { selectedObservations, setSelectedObservations, observations } = this.props.hqcStore;
        const items = observations[index].arr;
        let newSelectedObservations = this.findDuplicates(items, ['name', 'series_id', 'time', 'unit', 'value'])
        setSelectedObservations([...selectedObservations, ...newSelectedObservations]);
    }

    @observable compareOptionOne = null;
    @observable compareOptionTwo = null;

    @action setCompareOption = (index) => {
        if (this.compareOptionOne === index) {
            if (this.compareOptionTwo !== null) {
                this.compareOptionOne = this.compareOptionTwo;
                this.compareOptionTwo = null;
            } else {
                this.compareOptionOne = null;
            }
            return;
        }
        if (this.compareOptionTwo === index) {
            this.compareOptionTwo = null;
            return;
        }
        if (!this.compareOptionOne && this.compareOptionOne !== 0)
            this.compareOptionOne = index;
        else if (!this.compareOptionTwo && this.compareOptionTwo !== 0 && index !== this.compareOptionOne)
            this.compareOptionTwo = index;
    }

    calculatePercentageDifference = (value1, value2) => {
        if (value1 === 0) return '---'
        const diff = value1 - value2;
        if (Math.abs(diff) === value2) return '---'
        const percentage = (diff / value1) * 100;
        return `${percentage.toFixed(2)} %`;
    }


    render() {
        const { selectedDataSeries, data, setSelectedObservations, selectedObservations, setIgnore,
            ignore, firstPage, previousPage, nextPage, finalPage, pagination_size, pagination_index, pinned, groupedData } = this.props.hqcStore;

        const groupEachByRowIndex = {}

        Object.keys(groupedData).forEach(key => {
            const row_index_grouped = _.groupBy(groupedData[key], 'row_index');
            groupEachByRowIndex[key] = row_index_grouped;
        })

        return <div><table style={{ textAlign: 'center' }}>
            <thead>
                <tr>
                    <th style={{ textAlign: 'center', position: 'sticky', top: !(this.props.spaceForPin && pinned) ? 0 : 400, backgroundColor: '#3c8dbc', height: '44px' }}>
                        Station
                    </th>
                    {selectedDataSeries.map(item => {
                        const selectedStation = this.props.stationStore.findById(item.station_id);

                        return <th key={`parameter-${item.id}`}
                            style={{ textAlign: 'center', position: 'sticky', top: !(this.props.spaceForPin && pinned) ? 0 : 400, backgroundColor: '#3c8dbc', height: '44px' }}>
                            {selectedStation.name}
                        </th>
                    })}
                    {
                        this.compareOptionOne !== null && this.compareOptionTwo !== null &&
                        <th style={{ textAlign: 'center', position: 'sticky', top: !(this.props.spaceForPin && pinned) ? 44 : 444, backgroundColor: '#3c8dbc', height: '44px' }}>
                            Difference
                        </th>
                    }
                    {
                        this.compareOptionOne !== null && this.compareOptionTwo !== null &&
                        <th style={{ textAlign: 'center', position: 'sticky', top: !(this.props.spaceForPin && pinned) ? 44 : 444, backgroundColor: '#3c8dbc', height: '44px' }}>
                            Difference %
                        </th>
                    }
                </tr>
                <tr>
                    <th style={{ textAlign: 'center', position: 'sticky', top: !(this.props.spaceForPin && pinned) ? 44 : 444, backgroundColor: '#3c8dbc', height: '44px' }}>
                        Date Time
                    </th>
                    {selectedDataSeries.map((item, index) => {
                        return <th style={{ position: 'sticky', top: !(this.props.spaceForPin && pinned) ? 44 : 444, backgroundColor: '#3c8dbc' }} key={`time-${item.id}`}>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                {item.parameter ? item.parameter.code : ''}{item.parameter_unit ? `${item.parameter_unit.symbol ? `(${item.parameter_unit.symbol})` : ''}` : ''}
                                <input type={'checkbox'} checked={!!(!ignore.find(i => +i === +item.id))} onChange={(e) => {
                                    if (!e.target.checked) {
                                        setIgnore([...ignore, item.id]);
                                    } else {
                                        setIgnore([...ignore.filter(i => +i !== +item.id)]);
                                    }
                                }} />
                            </div>
                            <button style={{ padding: "5px", color: "#3c8dbc", fontWeight: "bold", cursor: "pointer" }} onClick={() => this.selectColumnDuplicates(index)}>Select duplicates</button>
                            {(this.compareOptionOne || this.compareOptionOne === 0) && this.compareOptionOne !== index ?
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <label>Compare</label>
                                    <input type="checkbox" checked={this.compareOptionTwo === index} onChange={(e) => {
                                        if (e.target.checked) {
                                            this.compareOptionTwo = index;
                                        } else {
                                            this.compareOptionTwo = null;
                                        }
                                    }} />
                                </div>
                                :
                                <div>
                                    <button onClick={() => this.setCompareOption(index)}
                                        style={{
                                            color: `${(this.compareOptionOne === index || this.compareOptionTwo === index) ? "#3fba00" : "#3c8dbc"}`,
                                            padding: "5px", fontWeight: "bold",
                                            cursor: "pointer",
                                        }}>
                                        Compare
                                    </button>
                                </div>
                            }
                        </th>
                    })}
                    {
                        this.compareOptionOne !== null && this.compareOptionTwo !== null &&
                        <th style={{ textAlign: 'center', position: 'sticky', top: !(this.props.spaceForPin && pinned) ? 44 : 444, backgroundColor: '#3c8dbc', height: '44px' }}>
                            {selectedDataSeries[this.compareOptionOne].parameter.code} - {selectedDataSeries[this.compareOptionTwo].parameter.code}
                        </th>
                    }
                    {
                        this.compareOptionOne !== null && this.compareOptionTwo !== null &&
                        <th style={{ textAlign: 'center', position: 'sticky', top: !(this.props.spaceForPin && pinned) ? 44 : 444, backgroundColor: '#3c8dbc', height: '44px' }}>
                            {selectedDataSeries[this.compareOptionOne].parameter.code} - {selectedDataSeries[this.compareOptionTwo].parameter.code}
                        </th>
                    }
                </tr>
            </thead>
            <tbody>
                {
                    [].concat(...Object.keys(groupEachByRowIndex).map((key, index) =>
                        Object.keys(groupEachByRowIndex[key]).map((row_index, i) => (
                            <tr >
                                <td>{getDisplayDate(+key)}</td>
                                {groupEachByRowIndex[key][row_index].sort((a, b) => a.column_index - b.column_index).map((o, index) => (
                                    <td
                                        style={{
                                            backgroundColor: returnBgColorByQcFlag(+o.qc_flag, this.props.getQcFlagEntryByFlag),
                                            color: returnColorByQcFlag(+o.qc_flag),
                                            borderWidth: selectedObservations.find(so => +so.id === +o.id) ? 'thick' : 0,
                                            borderStyle: 'solid',
                                            borderColor: 'black'
                                        }}
                                        onClick={() => {
                                            if (o.value) {
                                                if (selectedObservations.find(so => +so.id === +o.id)) {
                                                    setSelectedObservations(selectedObservations.filter(so => +so.id !== +o.id));
                                                } else {
                                                    setSelectedObservations([...selectedObservations, o]);
                                                }
                                            }
                                        }}>
                                        {(o.value || o.value === 0) ? (+o.value).toFixed(2) : '--'}
                                    </td>
                                ))}

                                {this.compareOptionOne !== null && this.compareOptionTwo !== null &&
                                    <td>
                                        {groupEachByRowIndex[key][row_index][this.compareOptionOne] && groupEachByRowIndex[key][row_index][this.compareOptionTwo] &&
                                            (groupEachByRowIndex[key][row_index][this.compareOptionOne].value || groupEachByRowIndex[key][row_index][this.compareOptionOne].value === 0) &&
                                            (groupEachByRowIndex[key][row_index][this.compareOptionTwo].value || groupEachByRowIndex[key][row_index][this.compareOptionTwo].value === 0) ?
                                            (groupEachByRowIndex[key][row_index][this.compareOptionOne].value - groupEachByRowIndex[key][row_index][this.compareOptionTwo].value).toFixed(2) : '--'}
                                    </td>

                                }

                                {this.compareOptionOne !== null && this.compareOptionTwo !== null &&
                                    <td>
                                        {groupEachByRowIndex[key][row_index][this.compareOptionOne] && groupEachByRowIndex[key][row_index][this.compareOptionTwo] &&
                                            (groupEachByRowIndex[key][row_index][this.compareOptionOne].value || groupEachByRowIndex[key][row_index][this.compareOptionOne].value === 0) &&
                                            (groupEachByRowIndex[key][row_index][this.compareOptionTwo].value || groupEachByRowIndex[key][row_index][this.compareOptionTwo].value === 0) ?
                                            `${this.calculatePercentageDifference(groupEachByRowIndex[key][row_index][this.compareOptionOne].value, +groupEachByRowIndex[key][row_index][this.compareOptionTwo].value)} ` : '--'}
                                    </td>

                                }
                            </tr>
                        ))
                    ))
                }
            </tbody>
        </table>
            <div style={{ position: 'sticky', bottom: 0, backgroundColor: 'white' }}>
                <button className='button' onClick={firstPage}><span className='white fa fa-backward' /></button>
                <button className='button' onClick={previousPage}><span className='white fa fa-caret-left' /></button>
                <span>{+pagination_index + 1}</span>
                <button className='button' onClick={nextPage}><span className='white fa fa-caret-right' /></button>
                <button className='button' onClick={finalPage}><span className='white fa fa-forward' /></button>
            </div>
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/components/HQC/_commons/ObservationsTable.js